<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>文章数据
    </div>
    <div class="content">
      <div class="condition">
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <el-input v-model="formdata.user" placeholder="请输入员工姓名"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="员工姓名"></el-table-column>
          <el-table-column prop="name" label="所属部门"></el-table-column>
          <el-table-column prop="address" label="获客数"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <span @click="datadetail(scope.row)" class="action_btn">查看客户数据</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination background layout="prev, pager, next" :total="50"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dataMember",
  data() {
    return {
      formdata: {
        user: ""
      },
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄"
        }
      ]
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    datadetail() {
      this.$router.push({ name: "dataCustomer" });
    }
  }
};
</script>